module.exports = __webpack_public_path__ + "static/img/bannerVR.6ba94347.jpg";